import { useABTreatiseCatalogRelations } from '@/hooks/PDP/usePublicationCatalogRelations';
import EcommPanelPublicationContent, {
  EcommPanelPublicationContentProps
} from './EcommPanelPublicationContent';
import { useEffect } from 'react';

type EcommPanelABTreatiseProps = Omit<
  EcommPanelPublicationContentProps,
  'catalogRelations' | 'libraryRelations'
>;

const EcommPanelABTreatise = ({
  isLoadingContent,
  content,
  params,
  onClose,
  context,
  itemListAnalyticsModel
}: EcommPanelABTreatiseProps) => {
  const catalogRelations = useABTreatiseCatalogRelations(content);

  useEffect(() => {
    if (catalogRelations?.isError) throw Error;
  }, [catalogRelations.isError]);

  return (
    <EcommPanelPublicationContent
      isLoadingContent={isLoadingContent}
      content={content}
      params={params}
      catalogRelations={catalogRelations}
      onClose={onClose}
      context={context}
      itemListAnalyticsModel={itemListAnalyticsModel}
    />
  );
};

export default EcommPanelABTreatise;
